import Vue from 'vue'
import Vuex from 'vuex'
import Storage from 'vue-ls'
import config from '../config/config';
import { fetchSiteData, getCountries, getColleges } from '../api/methods';
import { userSchema } from './schemas';

const options = {
  namespace: 'aa_',
  name: 'ls',
  storage: 'local'
}

Vue.use(Storage, options);

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    main: {
      title: "New Contemporaries",
      subtitle: "Admin Area",
      footer: {
        copyright__left: "",
        credits__right: ""
      }
    },
    mainMenu: [],
    user: userSchema,
    labels: {
    },
    countries: [],
    colleges: [],
    settings: {},
    options: [],
    snippets: [],
    questions: [],
    customToolbar: [
      [{ header: [false, 2, 3, 4, 5, 6] }, "bold", "italic"], ["link"], ["blockquote", { list: "ordered" }, { list: "bullet" }, "rule", "clean"]
    ],
  },
  getters: {
    main: state => state.main,
    mainMenu: state => state.mainMenu,
    user: state => state.user,
    labels: state => state.labels,
    settings: state => state.settings,
    countries: state => state.countries,
    colleges: state => state.colleges,
    options: state => state.options,
    snippets: state => state.snippets,
    questions: state => state.questions,
    customToolbar: state => state.customToolbar
  },
  mutations: {
    setMainMenu(state, data) {
      state.mainMenu = data.map(item => {
        item.hasChildren = false;
        if (item.children) {
          if (item.children instanceof Array) {
            item.hasChildren = item.children.length > 0;
          }
        }
        return item;
      });
    },
    setMain(state, data) {
      state.main = data;
    },
    setLabels(state, data) {
      if (data instanceof Array && data.length > 1) {
        state.labels = data;
      }
    },
    setOptions(state, data) {
      if (data instanceof Array && data.length > 1) {
        state.options = data;
      }
    },
    setCountries(state, data) {
      if (data instanceof Array && data.length > 1) {
        state.countries = data;
      }
    },
    setColleges(state, data) {
      if (data instanceof Array && data.length > 1) {
        state.colleges = data;
      }
    },
    setSettings(state, data) {
      if (data instanceof Object) {
        state.settings = data;
      }
    },
    setSnippets(state, data) {
      if (data instanceof Array) {
        state.snippets = data;
      }
    },
    setQuestions(state, data) {
      if (data instanceof Array) {
        state.questions = data;
      }
    },
    setUser(state, user) {
      if (user._id) {
        state.user = user;
      }
    }
  },
  actions: {
    getDataSets: async (store) => {

      fetchSiteData().then(data => {
        if (data.options) {
          store.commit("setOptions", data.options)
        }
        if (data.snippets) {
          store.commit("setSnippets", data.snippets)
        }
        if (data.settings) {
          if (data.settings instanceof Array) {
            let settings = {};
            data.settings.forEach(item => {
              if (item.key) {
                settings[item.key] = item.value;
              }
            })
            store.commit("setSettings", settings);
          }
        }
        if (data.questions) {
          store.commit("setQuestions", data.questions);
        }
        if (config.mainMenuItems) {
          store.commit("setMainMenu", config.mainMenuItems);
        }
      });

      getColleges().then(data => {
        if (data instanceof Array) {
          store.commit("setColleges", data);
        }
      });

      getCountries().then(data => {
        if (data instanceof Array) {
          store.commit("setCountries", data);
        }
      });
    },
    fetchUser: async (store) => {
      const user = Vue.ls.get('user');
      if (user instanceof Object && user._id) {
        store.commit("setUser", user);
      }
      return user;
    }
  }

});